import styled from "styled-components";
import COLORS from "../../../../assets/Colors";
import theme from "../../../../assets/theme";

export const MainContainer = styled.div`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
`;

export const Container = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  max-width: 100%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;
  border: 1px solid #a5bfcc;

  &:hover {
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
  }
`;

export const CreateContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 18px;
  padding-bottom: 12px;
  background-color: #eeeeee;
  border-radius: 10px;
  @media ${theme?.breakpoints?.sm_up} {
    padding-left: 46px;
    padding-right: 0;
    margin-top: 0;
    padding-bottom: 0;
  }
`;

export const StyledFormElementsWrapper = styled.div`
  margin-bottom: 28px;
  max-width: 100%;
  & .link {
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
  }
  & .template {
    margin-top: 0px;
  }
  & .waring-msg {
    color: ${COLORS.WARNING_COLOR};
    font-size: 10px;
    white-space: nowrap;
  }
  & .mediator-type {
    .MuiFormGroup-root {
      display: flex;
      flex-direction: column !important;
      & .MuiFormControlLabel-root {
        padding: 10px 0px;
      }
    }
  }
  @media ${theme?.breakpoints?.sm_down} {
    & .template {
      margin-top: 15px;
    }
  }
`;

export const StyledForm = styled.form`
  @media ${theme?.breakpoints?.sm_up} {
    width: 100%;
  }
  & .heading {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: space-between;
    & .delete {
      height: 20px;
      width: 20px;
      margin-bottom:15px;
      cursor: pointer;
      @media ${theme?.breakpoints?.sm_up} {
        margin: 34px 0 21px 0;
      }
    }
`;

export const FormLabel = styled.div`
  display: flex;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 12px;
  line-height: 1.4;
  color: ${COLORS.INPUT_LABEL};
  margin-bottom: 10px;
`;

export const ContainerGrid = styled.div`
  @media ${theme?.breakpoints?.sm_up} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 15px;
  }
`;

export const Grid = styled.div`
  @media ${theme?.breakpoints?.sm_up} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 15px;
  }
`;

export const Button = styled.div.attrs({ role: "button" })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 110px;
  height: 42px;
  padding: 0 24px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: ${theme.fonts.primaryFontBold};
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  transition: all 0.2s ease;

  &[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const StyledContainer = styled.div`
  & .doc_row {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 3px 0px;
    & .category {
      font-size: 16px;
      flex: 1;
      margin-left: 18px;
      color: ${COLORS.INPUT_LABEL};
      font-family: ${theme.fonts.primaryFontSemiBold};
    }
    & .name {
      font-size: 16px;
      font-weight: 600;
      flex: 1;
      margin-left: 15px;
      color: ${COLORS.COLOR_DARK};
      font-family: ${theme.fonts.primaryFontSemiBold};
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
`;

export const BackButton = styled(Button)`
  background: #ffffff;
  color: #00838c;
  border: 1px solid #00838c;

  &:hover {
    background: #ecfdf5;
  }
`;

export const SubmitButton = styled(Button)`
  background: #00838c;
  color: #ffffff;

  &:hover {
    background: #006f77;
  }
`;
